<template>
    <v-app>
        <v-sheet :height="500" :width="400" border rounded class="noAccessSheet">
            <div class="westatLogoHeader">
                <img src="../assets/westat.png" alt="logo" />
            </div>
            <img class="ma-3" src="../assets/wgmm_eagle_logo.svg" alt="logo" />
            <div class="ma-3">
                <p class="infoText">Select Study and View</p>
                <div class="searchTitle">STUDY</div>
                <v-select v-model="study" data-cy="study-view" :items="studies" density="compact" variant="outlined"
                    bg-color="white"></v-select>
                <div class="searchTitle">VIEW</div>
                <v-select v-model="page" data-cy="page-view" :items="pages" density="compact" variant="outlined"
                    :disabled="!study" bg-color="white"></v-select>
                <v-btn class="go-btn" data-cy="go-to-view" block @click="goToPage" :disabled="!page" style="margin-top: 20px">
                    Go
                </v-btn>
            </div>
        </v-sheet>
    </v-app>
</template>

<script>
import router from "@/router";
import { authTokenService } from "@/services/authTokenService.js";
import { STORE_CONSTANTS } from "@/common/store.constants";


export default {
    name: "home",
    data() {
        return {
            STORE_CONSTANTS,
            study: null,
            studies: [],
            page: null,
            pages: [],
            claims: null
        };
    },
    created() {
        this.claims = authTokenService.getClaims();
        this.studies = authTokenService.getAvailableStudies();

    },
    watch: {
        study(newValue) {
            authTokenService.setSelectedStudy(newValue)
            this.$store.dispatch(
                this.STORE_CONSTANTS.STUDY.ACTIONS.WITH_NAMESPACE.SET_SELECTED_STUDY,
                newValue
            )
                .catch((err) => {
                    console.error(err);
                });
            this.updateViewsOnStudyChange(newValue)
        },
        page(newValue) {
            authTokenService.setSelectedPage(newValue)
            this.$store.dispatch('loadPage', newValue);
        }
    },
    methods: {
        updateViewsOnStudyChange(study) {
            let roles = authTokenService.getRolesForStudy(study);
            this.pages = []
            if (roles.includes("ROLE_SPECIALIST") || roles.includes("ROLE_OPERATIONS") || roles.includes("FIELD_OPERATIONS")) {
                this.pages.push("Task Validation")
            }
            if (roles.includes("ROLE_SUPERVISOR") || roles.includes("ROLE_OPERATIONS")) {
                this.pages.push("Case Assignment")
            }
            if (roles.includes("ROLE_USER_MANAGE") || roles.includes("ROLE_OPERATIONS")) {
                this.pages.push("User Management")
            }
            if (roles.includes("FIELD_OPERATIONS") || roles.includes("ROLE_OPERATIONS")) {
                this.pages.push("Reporting")
            }
            this.page = this.pages[0]
        },
        goToPage() {
            const realStudy = authTokenService.getSelectedStudy();
            const realPage = authTokenService.getSelectedPage();
            if (!realPage || !realStudy) {
                return;
            }
            const pageRoutes = {
                "Task Validation": "/validation",
                "Case Assignment": "/assignment",
                "User Management": "/management",
                "Reporting": "/reporting",
            };

            const route = pageRoutes[realPage];
            if (route) {
                this.$router.push(route);
            }
        },
    }
};
</script>

<style scoped>
.noAccessSheet {
    margin-left: auto;
    margin-right: auto;
    margin-top: auto;
    margin-bottom: auto;
    background-color: rgb(240, 249, 254);
}

.westatLogoHeader {
    background-color: #f5f5f5;
    padding: 10px 15px;
}

.noAccessText {
    color: #15667c;
    font-size: 24px;
    margin-top: 50px;
}

.infoText {
    color: #15667c;
    font-size: 18px;
}
</style>